import Input from "./Input";
import PropTypes from "prop-types";
import React from "react";

function RoundedInput({
  type,
  name,
  onChange,
  placeholder,
  autoComplete,
  error,
  value,
  onBlur,
}) {
  return (
    <Input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      autoComplete={autoComplete}
      borderColor="offForeground"
      borderRadius="9999px"
      borderStyle="solid"
      borderWidth="1px"
      height={62}
      px={52}
      fontSize={"18px"}
      width="100%"
      error={error}
    />
  );
}

RoundedInput.propTypes = {
  autoComplete: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  error: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RoundedInput;
